export const URLS = {
  LOGIN: '/auth/sign-in',
  DASHBOARD: '/',
  CONSULTATION_DETAIL: '/consultation/consultation-details',
  CONSULTATION: '/consultation',
};
